import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import axios from "axios";

const ImageSlider = () => {
  const [bannerData, setBannerData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const fetchBannerData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}website/banners_list`,
      );

      if (response?.data?.result) {
        setBannerData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching banner data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBannerData();
  }, []);
  return (
    <Swiper
      modules={[Autoplay, Pagination, Navigation]}
      spaceBetween={30}
      slidesPerView={1}
      speed={1500}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      pagination={false}
      navigation={false}
      loop={true}
      breakpoints={{
        0: {
          height: 220,
        },
        768: {
          height: 200,
        },
      }}
      style={{
        width: "97%",
        margin: "20px auto",
        borderRadius: "20px",
        overflow: "hidden",
        height: "clamp(180px, 50vw, 450px)",

        
      }}
    >
      {bannerData?.map((item, index) => (
        <SwiperSlide key={index}>
          <img
            src={`${process.env.REACT_APP_API}uploads/${item?.banner_image}`}
            alt={`slide${index + 1}`}
            style={{ width: "100%", height: "100%", objectFit: "fill" }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ImageSlider;
